module.exports = __webpack_public_path__ + "img/cancel-success.75b542a1.svg";